import React, { useState, useEffect, useContext } from 'react';
import Swal from 'sweetalert2';
import instance from '../Config/AxiosConfig';
import Cookies from 'js-cookie';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import Sidebar from '../Layouts/Sidebar';
import TopBar from '../Layouts/TopBar';
import { AuthContext } from '../Context/AuthProvider';

function UpdateProject() {

    const { id } = useParams();
    const { user } = useContext(AuthContext);
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState('');
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        startDate: '',
        endDate: '',
        status: 'Accepted'
    });

    // Récupérer les détails du projet existant lors du chargement du composant
    useEffect(() => {
        const fetchProjectData = async () => {
            try {
                const token = Cookies.get('token');
                const response = await instance.get(`/projects/get/${id}`, token)
                if (response.status === 200) {
                    const project = response.data;
                    setFormData({
                        title: project.title,
                        description: project.description,
                        startDate: project.startDate,
                        endDate: project.endDate,
                        status: project.status,

                    });
                } else {
                    setErrors({ form: 'Failed to fetch project data.' });
                }
            } catch (error) {
                setErrors({ form: 'Error fetching project data.' });
            }
        };

        fetchProjectData();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const validateForm = () => {
        const errors = {};
        if (!formData.title) errors.title = 'Project name is required';
        if (!formData.description) errors.description = 'Project description is required';
        if (!formData.startDate) errors.startDate = 'Start date is required';
        if (!formData.endDate) errors.endDate = 'End date is required';
        return errors;
    };
    const history = useHistory()
    const handleUpdate = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const token = Cookies.get('token');
        const data = new FormData();
        data.append('title', formData.title);
        data.append('description', formData.description);
        data.append('startDate', formData.startDate);
        data.append('endDate', formData.endDate);
        data.append('status', 'Accepted');
        data.append('id', id);

        try {
            const response = await instance.post(`/projects/update/${id}`, data, token);

            if (response.status === 200) {
                Swal.fire({
                    text: "Project updated successfully!",
                    icon: "success"
                });
                setSuccess('Project updated successfully.');
                history.push(`/myproject/${user.id}`);
            } else {
                Swal.fire({
                    title: "Error!",
                    text: "Failed to update project.",
                    icon: "error"
                });
                setErrors({ form: 'Failed to update project.' });

            }
        } catch (error) {
            if (error.response) {
                setErrors({ form: 'Server error: ' + error.response.data.message });
            } else {
                setErrors({ form: 'Error updating project.' });
            }
        }
    };

    return (
        <>
            <TopBar />
            <main>
                <div class="container">
                    <div class="row g-4">

                        <div className="col-lg-3">
                            <Sidebar />
                        </div>

                        <div className="col-md-8 col-lg-6 vstack gap-4">
                            {/* Create a project START */}
                            <div className="card">
                                {/* Title START */}
                                <div className="card-header border-0 pb-0">

                                    <h1 className="h4 card-title mb-0">Update  Project</h1>

                                </div>

                                <div className="card-body">
                                    {errors.form && <p style={{ color: 'red' }}>{errors.form}</p>}
                                    {success && <p style={{ color: 'green' }}>{success}</p>}

                                    <form className="row g-3" >
                                        <div className="col-12">
                                            <label className="form-label">Project name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="title"
                                                value={formData.title}
                                                onChange={handleChange}
                                                placeholder="Project name (Required)"
                                            />
                                            {errors.title && <small style={{ color: 'red' }}>{errors.title}</small>}
                                        </div>

                                        <div className="col-12">
                                            <label className="form-label">About project</label>
                                            <textarea
                                                className="form-control"
                                                name="description"
                                                value={formData.description}
                                                onChange={handleChange}
                                                rows={3}
                                                placeholder="Description (Required)"
                                            />
                                            {errors.description && <small style={{ color: 'red' }}>{errors.description}</small>}
                                        </div>

                                        <hr />

                                        <div className="col-12">
                                            <h5 className="card-title mb-0">Date</h5>
                                        </div>

                                        <div className="col-sm-6">
                                            <label className="form-label">Start Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="startDate"
                                                value={formData.startDate}
                                                onChange={handleChange}
                                            />
                                            {errors.startDate && <small style={{ color: 'red' }}>{errors.startDate}</small>}
                                        </div>

                                        <div className="col-sm-6">
                                            <label className="form-label">End Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="endDate"
                                                value={formData.endDate}
                                                onChange={handleChange}
                                            />
                                            {errors.endDate && <small style={{ color: 'red' }}>{errors.endDate}</small>}
                                        </div>

                                        <div className="col-12 text-end mt-5">
                                            <button type="submit" className="btn btn-primary mb-0" onClick={handleUpdate}>Update Project</button>
                                        </div>
                                    </form>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>

                {/* Container END */}
            </main>

        </>
    );
}

export default UpdateProject;
